export const organisationPenalties: TableModule = {
    name: "organisationPenalties",
    route: "spa.organisations.organisationPenalties",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    routeParams: [{
        param: "organisation",
        prop: "organisation_id"
    }],
    columns: [
        {
            name: "penaltyFor",
            mobile: true,
        },
        {
            name: "gameDay",
            breakpoint: "md"
        },
        {
            name: "game",
            breakpoint: "md"
        },
        {
            name: "name",
            breakpoint: "md"
        },
        {
            name: "price",
            breakpoint: "md"
        },
        {
            name: "createdByUser",
            breakpoint: "md"
        },
        {
            name: "comment",
            breakpoint: "md"
        }
    ],
    filters: [],
    quickFilters: [],
    tools: []
}